import { Something_went_wrong } from '@root/app.constant';
import * as i0 from "@angular/core";
import * as i1 from "ngx-toastr";
export class ErrorHandler {
    constructor(toastr) {
        this.toastr = toastr;
    }
    handleError(data) {
        switch (data.status) {
            case -100:
                this.toastr.error(data.message);
                break;
            case -1:
                switch (data.error.errorCode) {
                    case -105:
                        this.toastr.error(data.error.errorMessage);
                        break;
                    case -2153:
                        this.toastr.error(data.error.errorMessage);
                        break;
                    case -2154:
                        this.toastr.error(data.error.errorMessage);
                        break;
                    case -21555:
                        this.toastr.error(data.error.errorMessage);
                        break;
                    case -2158:
                        this.toastr.error(data.error.errorMessage);
                        break;
                    case -2152:
                        this.toastr.error(data.error.errorMessage);
                        break;
                    case -204:
                        this.toastr.error(data.error.errorMessage);
                        break;
                    default:
                        this.toastr.error(Something_went_wrong);
                        break;
                }
                break;
            default:
                if (data.error) {
                    this.toastr.error(data.error.errorMessage);
                }
                break;
        }
    }
}
ErrorHandler.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ErrorHandler_Factory() { return new ErrorHandler(i0.ɵɵinject(i1.ToastrService)); }, token: ErrorHandler, providedIn: "root" });
